export default __webpack_public_path__ + "/dist/images/commission-icon.d87c4f07c612c3ad9167efbbf9e9cd21.svg";